export default "__VITE_ASSET__t2n9N1lH__"